import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IApplicationState, AppActionCreators, IAppState, ISwapQualityIssueListResponse, SwapQualityIssueActionCreators, ISwapQualityIssueCountResponse } from '@nkr/store/index';
import { IBaseResponse, ISwapQualityIssueCounts, ISwapQualityIssueForList, swapQualityIssueListTypeMap } from '@nkr/models/index';
import { SwapQualityIssueListType, SwapQualityIssueReportedBy } from '@nkr/enums/index';
import CenterList from './center-list';
import AdminList from './admin-list';
import SwapQualityIssuesNav from './nav';
import ConfirmReopen from './comfirm-reopen';
import { toast } from 'react-toastify';
import { FormControl } from 'react-bootstrap';
import { FormEvent } from 'react';

interface IProps extends RouteComponentProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getSwapQualityIssueList: (centerId: number, listType: SwapQualityIssueListType, reportedBy: number) => Promise<ISwapQualityIssueListResponse>,
    getCounts: (centerId: number, reportedBy: number) => Promise<ISwapQualityIssueCountResponse>,
    reopen: (issueId: number, centerId: number) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: ISwapQualityIssueForList[],
    reportedBy: SwapQualityIssueReportedBy,
    listType: SwapQualityIssueListType,
    counts: ISwapQualityIssueCounts,
    confirmReopen: {
        show: boolean,
        data: ISwapQualityIssueForList
    }
}

class SwapQualityIssueList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        reportedBy: SwapQualityIssueReportedBy.EitherCenter,
        listType: null,
        counts: {
            pendingResponse: 0,
            issueReportedIncomplete: 0,
            issueReportedCompleted: 0,
            noIssueReported: 0,
            total: 0
        },
        confirmReopen: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    componentDidUpdate = (prevProps: Readonly<TProps>, prevState: Readonly<IState>, snapshot?: any) => {
        if (this.props.location.pathname != prevProps.location.pathname) {
            this.getData();
        }
    }

    getListType = () => {
        let item = swapQualityIssueListTypeMap.find(x => window.location.href.indexOf(x.url) >= 0);

        if (item != null) {
            return item.type;
        }

        return SwapQualityIssueListType.PendingResponse;
    }

    getData = () => {
        let listType = this.getListType();

        let parsed = qs.parse(window.location.search);
        let reportedBy = parsed.reportedBy != null ? parseInt(parsed.reportedBy) : SwapQualityIssueReportedBy.EitherCenter;

        this.props.showLoading('Getting swap quality issues, one moment please...').then(async () => {
            let countsResponse = await this.props.getCounts(this.props.centerId, reportedBy);
            let listResponse = await this.props.getSwapQualityIssueList(this.props.centerId, listType, reportedBy);

            if (countsResponse.data.success && listResponse.data.success) {
                this.setState({
                    list: listResponse.data.results,
                    listType,
                    counts: countsResponse.data.results,
                    reportedBy
                }, () => {
                    this.props.hideLoading();
                });
            }
        });
    }

    refreshData = () => {
        this.props.showLoading('Getting swap quality issues, one moment please...').then(async () => {
            let countsResponse = await this.props.getCounts(this.props.centerId, this.state.reportedBy);
            let listResponse = await this.props.getSwapQualityIssueList(this.props.centerId, this.state.listType, this.state.reportedBy);

            if (countsResponse.data.success && listResponse.data.success) {
                this.setState({
                    list: listResponse.data.results,
                    // listType,
                    counts: countsResponse.data.results,
                    // reportedBy
                }, () => {
                    this.props.hideLoading();
                });
            }
        });
    }

    handleReportedByChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            reportedBy: parseInt(e.currentTarget.value)
        }, () => {
            this.refreshData();

            let url = this.props.location.pathname;

            this.props.history.push(url + '?reportedBy=' + this.state.reportedBy);
        });
    }

    handleConfirmReopen = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            confirmReopen: {
                show: true,
                data
            }
        });
    }

    handleReopen = () => {
        let issueId = this.state.confirmReopen.data.id;

        this.setState({
            confirmReopen: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Reopening swap quality report, one moment please...').then(() => {
                this.props.reopen(issueId, this.props.centerId)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Reopened successfully');
                            this.refreshData();
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    })
            });
        });
    }

    handleCancelReopen = () => {
        this.setState({
            confirmReopen: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        const listType = swapQualityIssueListTypeMap.find(x => window.location.href.indexOf(x.url) >= 0);
        const list = this.state.list;

        return (
            <>
                {!this.props.isAdmin && (
                    <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "75vh", paddingTop: 0, paddingLeft: 10, paddingRight: 10, paddingBottom: 10, backgroundColor: "#FFF" }}>
                        <SwapQualityIssuesNav
                            counts={this.state.counts}
                            reportBy={this.state.reportedBy}
                            activeKey={listType.url.toUpperCase()}
                            isAdmin={false}
                            isNkrLogin={this.props.app.user.group.isSuper}
                            centerId={this.props.centerId}
                        />

                        <div style={{ borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', padding: 20 }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Reported By:</div>
                                <div>
                                    <FormControl
                                        componentClass='select'
                                        bsSize='sm'
                                        value={this.state.reportedBy}
                                        onChange={this.handleReportedByChange}>
                                        <option value={SwapQualityIssueReportedBy.EitherCenter}>- Either Center -</option>
                                        <option value={SwapQualityIssueReportedBy.YourCenter}>Your Center</option>
                                        <option value={SwapQualityIssueReportedBy.OtherCenters}>Other Centers</option>
                                    </FormControl>
                                </div>
                            </div>
                            <CenterList
                                centerId={this.props.centerId}
                                data={list}
                                listType={this.state.listType}
                                reportedBy={this.state.reportedBy}
                                isAdminLogin={this.props.app.user.group.isSuper}
                                onConfirmReopen={this.handleConfirmReopen}
                            />

                            {list.length} item(s) found...
                        </div>
                    </div>
                )}

                {this.props.isAdmin && (
                    <div style={{ width: "100%" }}>
                        <AdminList
                            centerId={this.props.centerId}
                            data={list}
                            listType={this.state.listType}
                            reportedBy={this.state.reportedBy}
                            onConfirmReopen={this.handleConfirmReopen}
                        />

                        <div>{list.length} microsites shown...</div>
                    </div>
                )}

                <ConfirmReopen
                    show={this.state.confirmReopen.show}
                    data={this.state.confirmReopen.data}
                    onConfirm={this.handleReopen}
                    onCancel={this.handleCancelReopen} />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getSwapQualityIssueList: (centerId, listType, reportedBy) => {
            return dispatch(SwapQualityIssueActionCreators.getSwapQualityIssues(centerId, listType, reportedBy));
        },
        getCounts: (centerId, reportedBy) => {
            return dispatch(SwapQualityIssueActionCreators.getCounts(centerId, reportedBy));
        },
        reopen: (issueId, centerId) => {
            return dispatch(SwapQualityIssueActionCreators.reopen(issueId, centerId));
        }
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapQualityIssueList));